import {IconButton} from "@material-ui/core";
import React, {
  forwardRef, useEffect, useRef, useState,
} from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import dotsLogo from '../../../../../../img/three_points.svg';
import { CustomToggle } from '../../../../common/CustomToggle';

import PortalComponent from '../../../../PortalComponent/PortalComponent';

import styleAction from './style.module.less';

function TableAction({children, width, tooltip = 'Действ.', actionsDisabled = false, style = {},...rest
}) {
  const {imageProps}={...rest}
  const ref = useRef(null);
  useEffect(() => {
    ref.current.style.position = 'fixed';
    ref.current.style.zIndex = '999';
  }, []);
  const image = <img src={dotsLogo} />
  return (
    <div>
      <Dropdown className={styleAction.dropdown}>
        <Dropdown.Toggle as={CustomToggle} id="dropdown-edit">
          <Tooltip title={tooltip}>
            {!(imageProps?.imageButton!=null && !imageProps?.imageButton) ?
            <IconButton
                style={{display:'flex'}}
              color="inherit"
            >
              {image}
            </IconButton>
                : image
            }
          </Tooltip>
        </Dropdown.Toggle>
        <div ref={ref}>
          <PortalComponent id="portal-root">
            <Dropdown.Menu
              style={{...{
                zIndex: 99, flexDirection: 'column', paddingLeft: '15px', paddingRight: '15px', width,
              },...style}}
              // filtered={false} // Received `false` for a non-boolean attribute `filtered`
            >
              {children}
            </Dropdown.Menu>
          </PortalComponent>
        </div>
      </Dropdown>
    </div>

  );
}

export default TableAction;
